// QA check with HW

import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0Article} from './inventory/api.v0.article';
import {ApiV0Computer} from './inventory/api.v0.computer';
import {ApiV0Display} from './inventory/api.v0.display';

export class ApiV0Inventory {

    segment: string;

    constructor(v0: ApiV0, api: RestApiService) {
        this.segment = v0.segment + '/inventory';
        this.article = new ApiV0Article(this, api);
        this.computer = new ApiV0Computer(this, api);
        this.display = new ApiV0Display(this, api);
    }

    public readonly article: ApiV0Article;
    public readonly computer: ApiV0Computer;
    public readonly display: ApiV0Display;
}

